import { QueryFunction, QueryKey, useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { ApiError } from 'src/config/request';

export type Fetcher<T = Response> = QueryFunction<T, QueryKey>

export type Options<Response> = {
  initialData?: Response;
  enabled?: boolean;
  staleTime?: number;
  refetchOnWindowFocus?: boolean;
  refetchOnReconnect?: boolean;
  refetchOnMount?: boolean;
  retry?: number;
  cacheTime?: number;
  retryDelay?: number;
};

const useRequest = <Response>(
  url: string,
  fetcher: Fetcher<Response>,
  options: Options<Response> = {},
  queryKeys: string[] = []
) => {
  const queryClient = useQueryClient();

  const invalidate = useCallback(() => {
    queryClient.invalidateQueries([url]);
  }, [queryClient, url]);

  return {
    invalidate,
    ...useQuery<Response, ApiError>([url, ...queryKeys], fetcher, {
      ...options
    })
  };
};

export default useRequest;
